import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "sources" }
const _hoisted_2 = { class: "rest" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SourcesGround = _resolveComponent("SourcesGround")
  const _component_Source = _resolveComponent("Source")
  const _component_SourceWrap = _resolveComponent("SourceWrap")
  const _component_Collapse = _resolveComponent("Collapse")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SourcesGround, {
      loading: $props.loading,
      sources: $props.sources,
      class: "sources-ground",
      "show-all": $data.show_all,
      "cols-count": $options.cols_cnt,
      "col-width": $options.cols_width,
      onShowAll: _cache[0] || (_cache[0] = $event => ($data.show_all = true))
    }, null, 8 /* PROPS */, ["loading", "sources", "show-all", "cols-count", "col-width"]),
    _createCommentVNode(" REST ITEMS "),
    ($options.rest_items)
      ? (_openBlock(), _createBlock(_component_Collapse, {
          key: 0,
          open: $data.show_all,
          class: _normalizeClass(["rest-items", [$data.overflow]]),
          onAfterEnter: _cache[2] || (_cache[2] = $event => ($data.overflow = false)),
          onBeforeLeave: _cache[3] || (_cache[3] = $event => ($data.overflow = true))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.rest_items, (source, i) => {
                return (_openBlock(), _createBlock(_component_Source, {
                  key: i,
                  class: "source",
                  data: source,
                  num: $options.cols_cnt + i + 1
                }, null, 8 /* PROPS */, ["data", "num"]))
              }), 128 /* KEYED_FRAGMENT */)),
              _createVNode(_component_SourceWrap, {
                class: "less",
                pointer: "",
                onClick: _cache[1] || (_cache[1] = _withModifiers($event => ($data.show_all = false), ["prevent"]))
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode(" View less ")
                ])),
                _: 1 /* STABLE */
              })
            ])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["open", "class"]))
      : _createCommentVNode("v-if", true)
  ]))
}